import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys/glossary';

import { searchGlossaryTermApi, type SearchGlossaryTermParams } from '@/features/glossary/api/searchGlossaryTermApi';

type UseSearchGlossaryTermParams = {
  q?: string;
  glossaryFqn?: string;
  limit?: number;
  offset?: number;
  enabled?: boolean;
};

export const useSearchGlossaryTerm = ({
  q = '',
  glossaryFqn = '',
  offset = 0,
  enabled = true,
}: UseSearchGlossaryTermParams) => {
  return useQueryWithBoundary({
    queryKey: glossaryKeys.search(q, glossaryFqn, offset),
    queryFn: async () => {
      const params: SearchGlossaryTermParams = {
        q,
        glossaryFqn,
        offset,
      };
      return await searchGlossaryTermApi(params);
    },
    enabled: enabled && !!glossaryFqn,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
